import * as React from 'react'
import '../styles/App.scss'
import '../styles/JobItemDetails.scss'
import { ROUTES } from '../constants/routes'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

interface JobDetailsProps {
    onSetItemsOutside?: (areItemsOutside: boolean) => void
    onSetItemsInside?: (areItemsInside: boolean) => void
    onSetElevatorNeeded?: (isElevatorNeeded: boolean) => void
    onSetStairsNeeded?: (areStairsNeeded: boolean) => void
    areItemsOutside: boolean
    areItemsInside: boolean
    isElevatorNeeded: boolean
    areStairsNeeded: boolean
    completedJob?: any
    pathname?: string
}

interface JobDetailsState {
    outsideChecked: boolean
    insideChecked: boolean
    elevatorChecked: boolean
    stairsChecked: boolean
}

export default class JobItemDetails extends React.Component<
    JobDetailsProps,
    JobDetailsState
> {
    constructor(props: JobDetailsProps) {
        super(props)
        this.state = {
            outsideChecked: this.props.areItemsOutside,
            insideChecked: this.props.areItemsInside,
            elevatorChecked: this.props.isElevatorNeeded,
            stairsChecked: this.props.areStairsNeeded
        }
    }

    componentWillReceiveProps(nextProps: any) {
        if (this.state !== nextProps) {
            this.setState({
                outsideChecked: nextProps.areItemsOutside,
                insideChecked: nextProps.areItemsInside,
                elevatorChecked: nextProps.isElevatorNeeded,
                stairsChecked: nextProps.areStairsNeeded
            })
        }
    }

    handleOutsideCheck = () => {
        this.setState(prevState => {
            let outsideChecked = !prevState.outsideChecked
            if (this.props.onSetItemsOutside) {
                this.props.onSetItemsOutside(outsideChecked)
            }
            return { ...prevState, outsideChecked }
        })
    }

    handleInsideCheck = () => {
        this.setState(prevState => {
            let insideChecked = !prevState.insideChecked
            if (this.props.onSetItemsInside) {
                this.props.onSetItemsInside(insideChecked)
            }
            return { ...prevState, insideChecked }
        })
    }

    handleElevatorCheck = () => {
        this.setState(prevState => {
            let elevatorChecked = !prevState.elevatorChecked
            if (this.props.onSetElevatorNeeded) {
                this.props.onSetElevatorNeeded(elevatorChecked)
            }
            return { ...prevState, elevatorChecked }
        })
    }

    handleStairsCheck = () => {
        this.setState(prevState => {
            let stairsChecked = !prevState.stairsChecked
            if (this.props.onSetStairsNeeded) {
                this.props.onSetStairsNeeded(stairsChecked)
            }
            return { ...prevState, stairsChecked }
        })
    }

    render() {
        let disabled =
            this.props.completedJob ||
            this.props.pathname === ROUTES.PUBLISHED_JOB ||
            this.props.pathname === ROUTES.BID_ACCEPTED
                ? true
                : false

        return (
            <div className="Pickup-info">
                {disabled ? null : (
                    <div className="title">
                        {StringResources.getString(
                            Strings.Components.JobItemDetails.Title
                        )}
                    </div>
                )}

                <div
                    className={
                        disabled
                            ? 'checkbox-item-buttons completed'
                            : 'checkbox-item-buttons'
                    }
                >
                    <p>
                        {StringResources.getString(
                            Strings.Components.JobItemDetails.Text.ItemsAre
                        )}
                    </p>
                    <div className="inp-cbx-group">
                        <input
                            tabIndex={0}
                            type="checkbox"
                            id="cbx"
                            className={`inp-cbx-1 inp-cbx-${this.state.outsideChecked}`}
                            onClick={this.handleOutsideCheck}
                            disabled={disabled}
                        />
                        <label
                            htmlFor="cbx"
                            className={disabled ? 'cbx completed' : 'cbx'}
                        >
                            <span>
                                <svg
                                    width="12px"
                                    height="10px"
                                    viewBox="0 0 12 10"
                                >
                                    <polyline points="1.5 6 4.5 9 10.5 1" />
                                </svg>
                            </span>
                            <span className="cbx-text">
                                {StringResources.getString(
                                    Strings.Components.JobItemDetails.Text
                                        .Outside
                                )}
                            </span>
                        </label>
                    </div>
                    <div className="inp-cbx-group">
                        <input
                            type="checkbox"
                            id="cbx-2"
                            className={`inp-cbx-1 inp-cbx-2-${this.state.insideChecked}`}
                            onClick={this.handleInsideCheck}
                            disabled={disabled}
                        />
                        <label
                            htmlFor="cbx-2"
                            className={disabled ? 'cbx-2 completed' : 'cbx-2'}
                        >
                            <span>
                                <svg
                                    width="12px"
                                    height="10px"
                                    viewBox="0 0 12 10"
                                >
                                    <polyline points="1.5 6 4.5 9 10.5 1" />
                                </svg>
                            </span>
                            <span className="cbx-text">
                                {StringResources.getString(
                                    Strings.Components.JobItemDetails.Text
                                        .Inside
                                )}
                            </span>
                        </label>
                    </div>
                </div>
                <div
                    className={
                        disabled
                            ? 'checkbox-item-buttons completed'
                            : 'checkbox-item-buttons'
                    }
                >
                    <div style={{ paddingLeft: '75px', display: 'inline' }}>
                        <input
                            type="checkbox"
                            id="cbx-3"
                            className={`inp-cbx-1 inp-cbx-3-${this.state.elevatorChecked}`}
                            onClick={this.handleElevatorCheck}
                            disabled={disabled}
                        />
                        <label
                            htmlFor="cbx-3"
                            className={disabled ? 'cbx-3 completed' : 'cbx-3'}
                        >
                            <span>
                                <svg
                                    width="12px"
                                    height="10px"
                                    viewBox="0 0 12 10"
                                >
                                    <polyline points="1.5 6 4.5 9 10.5 1" />
                                </svg>
                            </span>
                            <span className="cbx-text">
                                {StringResources.getString(
                                    Strings.Components.JobItemDetails.Text
                                        .JobRequiresElevator
                                )}
                            </span>
                        </label>
                    </div>
                </div>

                <div
                    className={
                        disabled
                            ? 'checkbox-item-buttons completed'
                            : 'checkbox-item-buttons'
                    }
                >
                    <div style={{ paddingLeft: '75px', display: 'inline' }}>
                        <input
                            type="checkbox"
                            id="cbx-4"
                            className={`inp-cbx-1 inp-cbx-4-${this.state.stairsChecked}`}
                            onClick={this.handleStairsCheck}
                            disabled={disabled}
                        />
                        <label
                            htmlFor="cbx-4"
                            className={disabled ? 'cbx-4 completed' : 'cbx-4'}
                        >
                            <span>
                                <svg
                                    width="12px"
                                    height="10px"
                                    viewBox="0 0 12 10"
                                >
                                    <polyline points="1.5 6 4.5 9 10.5 1" />
                                </svg>
                            </span>
                            <span className="cbx-text">
                                {StringResources.getString(
                                    Strings.Components.JobItemDetails.Text
                                        .JobRequiresStairs
                                )}
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/JobItemDetails.tsx